import { RefreshCw } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import type { FeedbackTemplate } from '../../mentorshipService';

type Props = {
    template: FeedbackTemplate;
    onInsert: (text: string) => void;
    onRegenerate: () => void;
    regenerating: boolean;
};

function FeedbackTemplateOptions({ template, onInsert, onRegenerate, regenerating }: Props) {
    return (
        <Card variant="stacked" className="feedback-template">
            <Card.Header>
                <h3>Quick feedback templates</h3>
                <Button
                    variant="ghost"
                    size="sm"
                    icon={<RefreshCw size={14} />}
                    onClick={onRegenerate}
                    disabled={regenerating}
                >
                    {regenerating ? 'Regenerating…' : 'Regenerate'}
                </Button>
            </Card.Header>
            <Card.Body>
                <div className="feedback-template__options">
                    {template.quick_options.map((opt, i) => (
                        <Button
                            key={i}
                            variant="secondary"
                            size="md"
                            onClick={() => onInsert(opt)}
                        >
                            {opt}
                        </Button>
                    ))}
                </div>
                {template.focus_areas.length > 0 && (
                    <div className="feedback-template__focus">
                        <h4>Focus areas</h4>
                        {template.focus_areas.map((f) => (
                            <span key={f} className="mentorship-chip mentorship-chip--module">{f}</span>
                        ))}
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}

export default FeedbackTemplateOptions;
